import ApiCall from "utils/apiCall";
import Cookies from "js-cookie";
import { isOrganicAccess } from "utils/isOrganicAccess";
import * as Sentry from "@sentry/react";

const initialState = {
  isFetching: false
};

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "utm.isFetching":
      return { ...state, isFetching: true };

    case "utm.fetchSuccess":
      return { ...state, isFetching: false };

    case "utm.fetchError":
      return { ...state, isFetching: false };

    default:
      return state;
  }
}

// Actions
export function sendUtm() {
  return dispatch => {
    let spocketUtm = Cookies.get("spocket_utm");
    const isOrganic = isOrganicAccess();
    if (!spocketUtm && isOrganic) {
      spocketUtm = "?utm_source=organic";
    }
    if (spocketUtm) {
      // we want to add other cookies to utm payload
      // so far, we want to add the ps_xid cookie
      // but we can add more if needed
      let updatedUtm = spocketUtm;
      const otherCookies = [
        "ps_xid", // partner stack
        "sscid", // share a sale
        "irclickid" // impact radius
      ];
      otherCookies.forEach(name => {
        const value = Cookies.get(name);
        if (value) {
          updatedUtm += `&${name}=${value}`;
        }
      });

      // Append journey information if available
      try {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const journeyFromQuery = urlSearchParams.get("journey");
        const journeyFromStorage =
          typeof localStorage !== "undefined" ? localStorage.getItem("landing_page_signup") : null;
        const journey = journeyFromQuery || journeyFromStorage;
        if (journey) {
          updatedUtm += `&journey=${encodeURIComponent(journey)}`;
        }
      } catch (_) {
        // no-op if window or URLSearchParams is not available
      }

      dispatch({ type: "utm.isFetching" });
      ApiCall.post(`/stores/utm`, formatUtm(updatedUtm))
        .then(() => dispatch({ type: "utm.fetchSuccess" }))
        .catch(error => {
          dispatch({ type: "utm.fetchError", error });
          Sentry.captureException(error, { contexts: { storeUtm: { utm: updatedUtm } } });
        });
    }
  };
}

// Utils
const formatUtm = utms => {
  const arrayOfUtms = utms
    .split("?")[1]
    .split("&")
    .map(utm => {
      const splitedUtm = utm.split("=");
      const key = splitedUtm[0];
      const value = splitedUtm[1];
      return { [key]: value };
    });

  return Object.assign({}, ...arrayOfUtms);
};
